<script lang="ts" setup>
import PageHeader from '@/home/components/PageHeader.vue';
import PageFooter from '@/home/components/PageFooter.vue';
import PopupCard from '@/home/components/PopupCard.vue';
import NoticeBar from '@/home/components/NoticeBar.vue';

defineOptions({
  name: 'LayoutNormal',
});
</script>

<template>
  <NoticeBar v-if="$route.path === '/'" />
  <PopupCard />
  <PageHeader />
  <slot></slot>
  <PageFooter v-if="$route.path !== '/'" />
</template>

<style lang="scss" scoped>
</style>
